import "../Css/home.css"

export default function Counter({num , head }) {
  return (
    <div className='Counter'>
      <div className="counter-texts">
        <h2>{num}</h2>
        <p>{head}</p>
      </div>
    </div>
  )
}
